import { useState } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { GET_ALL_COMPANIES_QUERY_KEY } from './useServerLogisticCompany'
import { ICompany } from '../interfaces/interfaces'
import { mockedData } from '../mock/mocked'

export function useLogisticCompany() {
  const queryClient = useQueryClient()

  const [editExpedient, setEditExpedient] = useState<ICompany | undefined>()
  const [showNewCompany, setShowNewCompany] = useState<boolean>(false)
  const refetch = () =>
    queryClient.invalidateQueries({ queryKey: [GET_ALL_COMPANIES_QUERY_KEY] })

  const [dataTable, setDataTable] = useState<ICompany[]>(mockedData.slice(0, 5))
  const [currentPage, setCurrentPage] = useState(1)

  const goToPage = (page: number) => {
    setCurrentPage(page)
    setDataTable(mockedData.slice((page - 1) * 5, page * 5))
  }
  const goToNextPage = () => {
    setCurrentPage(currentPage + 1)
    setDataTable(mockedData.slice(currentPage * 5, (currentPage + 1) * 5))
  }
  const goToPreviousPage = () => {
    setCurrentPage(currentPage - 1)
    setDataTable(mockedData.slice((currentPage - 2) * 5, (currentPage - 1) * 5))
  }

  const search = {
    action: (searchQuery: string) => {
      if (searchQuery !== '')
        setDataTable(
          mockedData.filter((item) => item.name.includes(searchQuery))
        )
      else
        setDataTable(mockedData.slice((currentPage - 1) * 5, currentPage * 5))
    },
    placeholder: 'Buscar expediente',
  }

  const onClose = () => {
    //setEditExpedient(undefined)
    setShowNewCompany(false)
  }

  const paginate = {
    currentPage: currentPage,
    totalItems: mockedData.length,
    goToPage,
    goToNextPage,
    goToPreviousPage,
  }

  const onEditClick = () => {
    setShowNewCompany(true)
  }

  const onNewCompany = () => {
    setEditExpedient(undefined)
    setShowNewCompany(true)
  }
  const onChangeFilter = (newFilters: Record<string, string>) => {
    setDataTable(
      mockedData.filter((item) => newFilters['type'].includes(item.type))
    )
  }

  return {
    dataTable,
    search,
    refetch,
    paginate,
    onEditClick,
    editExpedient,
    showNewCompany,
    onNewCompany,
    onClose,
    onChangeFilter,
  }
}
